import { createFileRoute } from '@tanstack/react-router';
import UserEdit from '~/containers/UserEdit';

export const Route = createFileRoute('/users/$publisherId/')({
  component: UserEdit,
});
